import { createActionGroup, props } from "@ngrx/store";
import { DashboardMeasureLocation } from "@models/dashboard-location.model";
import { DashboardProviderProd } from "@models/dashboard-providers.model";
import { DashboardMeasureDetailProd } from "@models/dashboard-measure-details.model";
import { DashboardFilterRequest } from "@models/dashboard-filter.model";
import { MonthlyTrend } from "@models/monthly-trend.model";
import { DashboardMipsScoreRequest, DashboardMipsScoreResponse } from "@models/dashboard-mips-scores.model";
import { DashboardMeasureDecile } from "@models/dashboard-measure-deciles.model";
import { CalculateMipsReweightingRequest, CalculateMipsReweightingResponse } from "@models/mips-reweighting-score.model";

export const DashboardActions = createActionGroup({
  source: "Dashboard",
  events: {
    "Get Dashboard Locations Success": props<{
      locations: DashboardMeasureLocation[];
    }>(),
    "Get Dashboard Locations Failure": props<{ error: string }>(),

    "Get Dashboard Providers Success": props<{
      providers: DashboardProviderProd[];
    }>(),
    "Get Dashboard Providers Failure": props<{ error: string }>(),

    "Get Dashboard Measure Summaries Success": props<{
      measures: DashboardMeasureDetailProd[];
    }>(),
    "Get Dashboard Measure Summaries Failure": props<{ error: string }>(),

    "Apply Filters": props<{
      orgId: number;
      filters: DashboardFilterRequest;
    }>(),

    "Click On Measure": props<{
      measure: DashboardMeasureDetailProd;
      index: number;
    }>(),
    "Toggle Measure Expansion": props<{
      measure: DashboardMeasureDetailProd;
      index: number;
    }>(),

    "Select Details Tab": props<{ tab: string }>(),

    "Get Measure Monthly Trend Success": props<{ trend: MonthlyTrend[] }>(),
    "Get Measure Monthly Trend Failure": props<{ error: string }>(),

    "Monthly Trend Months Changed": props<{ years: number[] }>(),

    "Set Small Practice": props<{ isSmallPractice: boolean }>(),

    "Load Dashboard Mips Scores": props<{
      orgId: number;
      reportingYear: number;
      request: DashboardMipsScoreRequest;
    }>(),
    "Load Dashboard Mips Scores Success": props<{
      data: DashboardMipsScoreResponse;
    }>(),
    "Load Dashboard Mips Scores Failure": props<{ error: string }>(),

    "Load Measure Favorites Success": props<{ measureCodes: string[] }>(),
    "Load Measure Favorites Failure": props<{ error: string }>(),

    "Toggle Measure Favorite": props<{ userId: string; measureCode: string; isFavorite: boolean }>(),
    "Add Measure Favorite Success": props<{ measureCode: string }>(),
    "Add Measure Favorite Failure": props<{ error: string }>(),
    "Remove Measure Favorite Success": props<{ measureCode: string }>(),
    "Remove Measure Favorite Failure": props<{ error: string }>(),

    "Load Dashboard Deciles": props<{ year: number }>(),
    "Load Dashboard Deciles Success": props<{ deciles: DashboardMeasureDecile[]; year: number }>(),
    "Load Dashboard Deciles Failure": props<{ error: string }>(),

    "Calculate Mips Reweighting": props<{ request: CalculateMipsReweightingRequest }>(),
    "Calculate Mips Reweighting Success": props<{ data: CalculateMipsReweightingResponse }>(),
    "Calculate Mips Reweighting Failure": props<{ error: string }>(),

    "Set Is Multi Org Tin": props<{ isMultiOrgTin: boolean }>(),

    "Save Filter State": props<{
      measureSelection: string[];
      clinician: string[];
      location: string[];
      selectGroup: string;
      measureYear: string;
      isTinAggregationEnabled: boolean;
    }>(),
  },
});
